import { StrictMode } from 'react';
import CssBaseline from '@mui/material/CssBaseline';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import {
  LoadingProvider,
  PersistedTransactionIdProvider,
} from './BPay/context';

const theme = createTheme({
  cssVariables: true,
  palette: {
    text: {
      primary: '#333333',
      secondary: '#666666',
    },
  },
});

export const Infrastructure = ({ children }) => {
  return (
    <StrictMode>
      <ThemeProvider theme={theme}>
        <PersistedTransactionIdProvider>
          <LoadingProvider>
            <CssBaseline />
            {children}
          </LoadingProvider>
        </PersistedTransactionIdProvider>
      </ThemeProvider>
    </StrictMode>
  );
};
